var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFireFeaturesWindDirection = function SvgFireFeaturesWindDirection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#21272C",
    fillRule: "evenodd",
    d: "M18.881 7.46a1 1 0 1 0-1.414 1.414l2.129 2.129H13a1 1 0 1 0 0 2h6.59l-2.123 2.123a1 1 0 0 0 1.414 1.414l3.829-3.828a.997.997 0 0 0 .293-.7.997.997 0 0 0-.293-.724z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#21272C",
    d: "M12.17 7.324 9.59 16H8.018l-1.5-5.196L5.006 16H3.458L.872 7.324h1.986l1.482 5.19 1.452-5.19h1.452l1.488 5.19 1.452-5.19z"
  })));
};
export default SvgFireFeaturesWindDirection;